module.exports = __webpack_public_path__ + "static/kairos-sans-987d38255bd44570b740fd131c5620d8.ttf";